import React, { useMemo } from "react";
import { Icon, Menu } from "semantic-ui-react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../app/common/modals/modalSlice";

export default function NavBarSecondaryLarge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation().pathname;
  const locationPage = location?.substring(location?.lastIndexOf("/") + 1);
  const [page, setPage] = useState(locationPage);
  const { transaction } = useSelector((state) => state.transaction);
  const { currentUserProfile } = useSelector((state) => state.profile);
  let { id } = useParams();

  function handleMenuClick(page) {
    setPage(page);
    navigate(`/transactions/${id}/${page}`);
  }

  // Show Compliance menu only for transactions created on or after March 11, 2026
  const showComplianceMenu = useMemo(() => {
    if (!transaction?.createdAt) return false;
    const complianceLaunchDate = new Date("2026-03-15T00:00:00");
    const createdAt = transaction.createdAt?.toDate
      ? transaction.createdAt.toDate()
      : new Date(transaction.createdAt);
    return createdAt >= complianceLaunchDate;
  }, [transaction?.createdAt]); // eslint-disable-line react-hooks/exhaustive-deps

  // Only show Notify if there's someone besides the agent themselves to notify
  const hasNotifiableTeamMembers = !!(
    transaction?.managerId ||
    transaction?.tcId ||
    transaction?.coAgentId ||
    transaction?.hasAssistant
  );

  return (
    <div id="secondary-nav">
      <Menu vertical className="sidebar-menu">
        {transaction && (
          <>
            <Menu.Item style={{ wordBreak: "break-word", color: "#333333" }}>
              <h4 className="tiny bottom margin text-medium  tiny top margin">
                {transaction.agentRepresents}
              </h4>
              <p className="zero bottom margin">
                {transaction.client?.firstName} {transaction.client?.lastName}
              </p>
              {transaction.clientSecondaryExists && (
                <p className="zero bottom margin">
                  {transaction.clientSecondary?.firstName}{" "}
                  {transaction.clientSecondary?.lastName}
                </p>
              )}
              {transaction.clientThirdExists && (
                <p className="zero bottom margin">
                  {transaction.clientThird?.firstName}{" "}
                  {transaction.clientThird?.lastName}
                </p>
              )}
              {transaction.address && (
                <p className="zero bottom margin">
                  {transaction.address.street}
                </p>
              )}
            </Menu.Item>
            <br />
          </>
        )}
        <Menu.Item
          name="Overview"
          active={page === "overview"}
          onClick={() => handleMenuClick("overview")}
          data-test="overview-trans-nav"
        >
          Overview
          <Icon name="folder outline" />
        </Menu.Item>
        <Menu.Item
          name="Parties"
          active={page === "parties"}
          onClick={() => handleMenuClick("parties")}
          data-test="parties-trans-nav"
        >
          Parties <Icon name="user outline" />
        </Menu.Item>
        <Menu.Item
          name="Documents"
          active={page === "documents"}
          onClick={() => handleMenuClick("documents")}
          data-test="documents-trans-nav"
        >
          Documents <Icon name="file outline" />
        </Menu.Item>
        {showComplianceMenu && (
          <Menu.Item
            name="Compliance"
            active={page === "compliance"}
            onClick={() => handleMenuClick("compliance")}
          >
            Compliance <Icon name="check circle outline" />
          </Menu.Item>
        )}
        {/* showStrategyFeature gates an AGENT's own self-service access to
            the (metered, AI-cost-bearing) Strategy feature - but a Manager
            viewing one of their agents' transactions is exercising oversight
            access, not self-service, and the backend already allows it
            uniformly for managers (assertCanExecuteStrategy/
            canAccessTransaction) regardless of that specific agent's
            rollout flag - so a Manager should always see this tab here,
            independent of their own showStrategyFeature setting. */}
        {(currentUserProfile?.showStrategyFeature || currentUserProfile?.role === "manager") && (
          <Menu.Item
            name="Strategy"
            active={page === "strategy"}
            onClick={() => handleMenuClick("strategy")}
            data-test="strategy-trans-nav"
          >
            Strategy <Icon name="lightbulb outline" />
          </Menu.Item>
        )}
        {hasNotifiableTeamMembers && (
          <Menu.Item
            name="Notify"
            onClick={() =>
              dispatch(
                openModal({
                  modalType: "TransactionNotifyModal",
                  modalProps: { transaction },
                })
              )
            }
            data-test="notify-trans-nav"
          >
            Notify <Icon name="bullhorn" />
          </Menu.Item>
        )}
        {/* <Menu.Item
          name="deadline"
          active={page === "deadlines"}
          onClick={() => handleMenuClick("deadlines")}
          data-test="tasks-trans-nav"
        >
          Deadlines <Icon name="check square outline" />
        </Menu.Item> */}
        <Menu.Item
          name="tasks"
          active={page === "tasks"}
          onClick={() => handleMenuClick("tasks")}
          data-test="tasks-trans-nav"
        >
          Tasks <Icon name="list alternate outline" />
        </Menu.Item>
        <Menu.Item
          name="emails"
          active={page === "emails"}
          onClick={() => handleMenuClick("emails")}
        >
          Emails <Icon name="mail outline" />
        </Menu.Item>
        {/* <Menu.Item
          name="Calendar"
          active={page === "calendar"}
          onClick={() => handleMenuClick("calendar")}
          data-test="calendar-trans-nav"
        >
          Calendar <Icon name="calendar outline" />
        </Menu.Item> */}
        <Menu.Item
          name="History"
          active={page === "history"}
          onClick={() => handleMenuClick("history")}
        >
          History <Icon name="history" />
        </Menu.Item>
      </Menu>
    </div>
  );
}
